let _ = require('lodash');
let moment = require('moment');
let columnify = require('columnify');
let elvenStats = require('./elven-stats');


exports.getPossibleReportDates = function(users) {
    try {
        var user = _.first(_.sortBy(users, function(u) { return _.size(u.scoreHistory); }).reverse() );
        let dateList = _.map(user.scoreHistory, "day").reverse();

       // console.log("user for datelist", user);
        // console.log("DateList: ", dateList);
        if (_.size(dateList) > 2) {
            dateList =  _.take(dateList, _.size(dateList) - 1);
        }
        return _.map(dateList, function(d) {
            return {
                text: moment(d).format("LL"),
                value: d
            }
        })
    }catch(err) {
        console.error(err);
    }
    return [];
};

exports.getSampleReport = function() {
    return `-- SAMPLE WEEKLY REPORT --

### ACCOLADES ###
 - Tourney Hero: ruby1965 with 3900
 - Highest Growth (points): Corinzar with 18517
 - Highest Growth (percentage): Corinzar with 4.8%
 - Great Week: ruby1965 with 26966 more points than previous week

### NEW PERSONAL RECORDS
 * Lathlaeril set a new personal record for: Most Score Points Gain w/

### ALL MEMBERS BY POINT GAIN (THIS WEEK) ###
 18517  4.8% Corinzar
 18056  3.4% dogball
 17317  4.2% fasdfTTT
 10825  1.9% ruby1965
  8574  2.7% rlrgirl04
  8394  3.9% Lathlaeril
  5700  2.2% chevy1969
  4663  1.1% alff
  3426  0.6% tntitans
  3192  1.2% ShandaPanda
  3029  1.1% Mistborn
  3024  1.0% legadeath
  1698  1.0% tricolorkittie
  1566  0.8% Elven Chaos
  1092  0.3% Cavil
   520  0.1% Fanderay
   424  0.1% niteraven99
     0  0.0% raynewolf
  -925 -0.2% ProfessorOrange
 -4172 -1.0% GreenShield
 -6531 -1.1% Esme Foxglove
 -6737 -1.7% Steve9733
 -7434 -2.4% Zazbar
-19808 -4.0% Peaches10

### TOURNAMENT POINTS (THIS WEEK / LAST 4 WEEKS TOTAL)
3900 14010 ruby1965
3364 11860 dogball
3012 11598 legadeath
2874 12894 fasdfTTT
2513 10013 alff
2220 9558  GreenShield
1968 7284  Zazbar
1938 10362 Esme Foxglove
1908 3720  ShandaPanda
1872 8838  Cavil
1824 4766  tricolorkittie
1817 7256  rlrgirl04
1716 6762  Fanderay
1686 6686  ProfessorOrange
1680 6306  Peaches10
1560 6696  Lathlaeril
1554 4626  Mistborn
1386 4932  Steve9733
1350 7956  tntitans
1146 4368  Elven Chaos
952  4095  chevy1969
864  4944  raynewolf
410  2714  niteraven99
300  4450  Corinzar

### TOP 8 BY PERCENTAGE (THIS WEEK) ###
4.8% Corinzar
4.2% fasdfTTT
3.9% Lathlaeril
3.4% dogball
2.7% rlrgirl04
2.2% chevy1969
1.9% ruby1965
1.2% ShandaPanda

### TOP 8 BY PERCENTAGE (SINCE NOV 12) ###
55.7% niteraven99
47.8% fasdfTTT
47.4% legadeath
46.8% Elven Chaos
4.8%  Peaches10
38.6% Mistborn
36.2% chevy1969
32.9% Corinzar

### TOP 8 BY POINTS (SINCE NOV 12) ###
137940 fasdfTTT
117178 niteraven99
106983 dogball
101096 legadeath
100672 Corinzar
87606  GreenShield
87484  alff
85323  ruby1965

Report Generated by elvenstats.com`
};

function findScoreForDate( user, date ) {
    var score = _.find( user.scoreHistory, {day: moment.utc(date).format("YYYY-MM-DD")});
    return score ? parseInt( score.score ) : undefined;
}

function findTournamentForDate( user, date ) {
    var score = _.find( user.tournaments, function(t) {
        //console.log(moment.utc(t.date).format("YYYY-MM-DD") + " to " + moment.utc(date).format("YYYY-MM-DD") );
        return moment.utc(t.date).format("YYYY-MM-DD") === moment.utc(date).format("YYYY-MM-DD") });//day: moment.utc(date).format("YYYY-MM-DD")});
    return score ? parseInt( score.points ): 0;
}

function shortDate(date) {
    return moment.utc(date).format("ll")
}

// Increase ÷ Original Number × 100
function getPercentChanged( before, after, pretty) {
    var percent = (((after - before) / before) * 100).toFixed(1);
    return pretty ? percent + "%" : Number(percent);
}

function getLastTournamentScore(user, opts) {
    return findTournamentForDate(user, moment.utc(opts.reportDate).subtract(1,"day") );
}

exports.getLast4TournamentsSum = function(user, opts) {
    return findTournamentForDate(user, moment.utc(opts.reportDate).subtract(1,"day").subtract(0,"weeks")) +
           findTournamentForDate(user, moment.utc(opts.reportDate).subtract(1,"day").subtract(1,"weeks")) +
           findTournamentForDate(user, moment.utc(opts.reportDate).subtract(1,"day").subtract(2,"weeks")) +
           findTournamentForDate(user, moment.utc(opts.reportDate).subtract(1,"day").subtract(3,"weeks"));
}

// function getTournamentSum(user, numWeeks, opts) {
//     var tournaments = user.tournaments;
//     tournaments = _.filter( tournaments, function (t) {
//         t.points = parseInt( t.points );
//         return moment.utc().subtract(numWeeks, "weeks") < moment.utc(t.date);
//     });
//
//    // console.log("Tournaments included: " + _.size(tournaments))
//
//     return _.sumBy(tournaments, "points");
// }

/**
 *
 * @param {Object} opts
 * @param {String} opts.reportDate - should be something like "2018-07-12" and fall on a sunday.
 * @param {Boolean} opts.makeReportFitInOneMessage - default false, if true, it will not try and make the report fit into 2000 characters
 * @param {Object} opts.i18n - the vue-i18n object for localization
 * @param {String} opts.server
 * @param {Array} opts.users - must have scoreHistory on them.
 * @param {Number} [opts.tournamentWeeks] - sets how many weeks cumulative to total (default is 4).
 * @param callback
 * @returns {String}
 */
exports.weeklyFellowshipReport = function( opts ) {
    if( !opts || !opts.reportDate || !opts.users) { throw new Error("Missing required param"); }

    if( _.isObject(opts.reportDate) ) {
        opts.reportDate = opts.reportDate.value;
    }

    if( opts.makeReportFitInOneMessage === undefined ) {
        opts.makeReportFitInOneMessage = true;
    }

    //console.log(opts.reportDate, "is the report date");

    opts.usernameMaxLength = opts.usernameMaxLength || 14;
    let s = "";
    let stats = [];
    let currDate = moment.utc(opts.reportDate).toDate();
    let initialDate = moment.utc(opts.reportDate).subtract(4,'weeks').toDate();
    let initialDateShort = moment.utc(initialDate).format("ll");
    initialDateShort = initialDateShort.replace(/(,|.)? 20\d\d/, "");
    let prevDate = moment.utc(opts.reportDate).subtract(7, 'days').toDate();
    let prevDate2 = moment.utc(opts.reportDate).subtract(14, 'days').toDate();
    let weeklyBests = [];
    let insufficientDataForUsers = [];

    _.each(opts.users, function (user) {
        user.reportUsername = user.username.substring(0, opts.usernameMaxLength);
        let currScore = findScoreForDate( user, opts.reportDate );
        let prevScore = findScoreForDate( user, prevDate );
        let prevScore2 = findScoreForDate( user, prevDate2 );
        let initialScore = findScoreForDate( user, initialDate);

        let userStat = {
            username: user.username,
            reportUsername: user.reportUsername,
            currTournamentScore: getLastTournamentScore(user, opts),
            tournamentSum: exports.getLast4TournamentsSum(user, opts),
        };

        //console.log( "username: " + user.username + " prevScore: " + prevScore + " currScore: " + currScore)
        if( prevScore && currScore) {
            _.extend(userStat, {
                username: user.username,
                reportUsername: user.reportUsername,
                //currRank: -1,
                currScore: currScore,
                prevScore: prevScore,
                currDelta: currScore - prevScore,
                initialScore: initialScore,
                currPercent: getPercentChanged(prevScore, currScore, false),
                currPercentPretty: getPercentChanged(prevScore, currScore, true),
                totalDelta: currScore - initialScore,
                totalPercent: getPercentChanged(initialScore, currScore, false),
                totalPercentPretty: getPercentChanged(initialScore, currScore, true),
                prevDelta: prevScore2 ? prevScore - prevScore2 : 0,
                difference: prevScore2 ? (currScore - prevScore) - (prevScore - prevScore2) : undefined,
                predictedScore: prevScore2 ? currScore + (((currScore - prevScore) + ((prevScore - prevScore2))) / 2) : undefined,
                weeklyBest: getWeeklyBests(user, opts.reportDate,opts.i18n)
            });

            _.each(userStat.weeklyBest, function (best, key) {
                if( best && best.date ) {
                    if (moment.utc(best.date).startOf('day').format("YYYY-MM-DD") ===
                        moment.utc(opts.reportDate).startOf('day').format("YYYY-MM-DD")) {
                        weeklyBests.push(_.extend(best, { key: key, reportUsername: user.reportUsername }));
                    }
                }
            });
        }
        else {
            //console.log("adding " + user.username);
            insufficientDataForUsers.push(user.username);
        }

        stats.push(userStat);
    });

    let membersWithEnoughData = _.filter(stats, function(u) { return u.currDelta || u.currDelta === 0});
    let byGrowth = [];
    let top10 = [];

    //console.log( "_size: " + _.size(membersWithEnoughData) );

    // s += "\n### FELLOWSHIP OVERALL ###" + "\n";
    // s += " - Fellowship Grew by: " + fellowship.currDelta + " (" + fellowship.currPercentPretty + ") this week." + "\n";
    // console.log(" - Average growth/member: " + (fellowship.currDelta / 25).toFixed(0))
    s += ("### " + opts.i18n.t('site.fellowship.weeklyReport.accolades')).toUpperCase() + "\n";
    s += opts.i18n.t('site.fellowship.weeklyReport.tourneyChamp', [getAccolade(stats, "currTournamentScore","",opts.i18n)]) + "\n";
    s += opts.i18n.t('site.fellowship.weeklyReport.tourneyHero', [getAccolade(stats, "tournamentSum", "", opts.i18n)]) + "\n";

    let pointsAccolade = getAccoladeObj(membersWithEnoughData, "currDelta");
    let percentAccolade = getAccoladeObj(membersWithEnoughData, "currPercent");
    if( pointsAccolade && percentAccolade ) {
        if (pointsAccolade.username == percentAccolade.username) {
            s += opts.i18n.t('site.fellowship.weeklyReport.highestGrowthPlusPercentage', [getAccolade(membersWithEnoughData, "currDelta","",opts.i18n)]) + "\n";
        }
        else {
            s += opts.i18n.t('site.fellowship.weeklyReport.highestGrowthPoints', [getAccolade(membersWithEnoughData, "currDelta","",opts.i18n)]) + "\n";
            s += opts.i18n.t('site.fellowship.weeklyReport.highestGrowthPercentage', [getAccolade(membersWithEnoughData, "currPercent", "%",opts.i18n)]) + "\n";
        }
    }else {
        s += opts.i18n.t('site.fellowship.weeklyReport.highestGrowthError') + "\n";
    }
    //s += " - Great Week: " + getAccolade(membersWithEnoughData, "difference", " more points than previous week") + "\n";

    if( _.size(weeklyBests) > 0 && _.size(weeklyBests) < 8) {
        s += ("\n### " + opts.i18n.t('site.fellowship.weeklyReport.newPersonalRecords').toUpperCase() + "\n" )
        _.each( weeklyBests, function(b) {
            s += opts.i18n.t('site.fellowship.weeklyReport.userSetANewPersonalRecordFor', [b.reportUsername, b.description]) + " (" + b.value + ")\n";
        })
    }else {
        console.log("Too many weekly bests: " + _.size(weeklyBests))
    }


    s += "\n### " + opts.i18n.t('site.fellowship.weeklyReport.allMembersByPointGainThisWeek').toUpperCase() + "\n";
    if( _.size(membersWithEnoughData) > 0 ) {
        byGrowth = _.sortBy(membersWithEnoughData, "currDelta").reverse();
        top10 = _.dropRight(byGrowth, 0); //.splice(0,10);
        s += exports.makeTable(top10, {columns: ["currDelta", "currPercentPretty", "reportUsername"]}) + "\n";
        if( _.size(insufficientDataForUsers) > 0 ) {
            s += opts.i18n.t('site.fellowship.weeklyReport.insufficientHistoryForThesePlayers', [insufficientDataForUsers.join(' & ')]) + "\n";
        }
    } else {
        s += opts.i18n.t('site.fellowship.weeklyReport.insufficientHistory1Week') + "\n\n";
    }

    s += "### " + opts.i18n.t('site.fellowship.weeklyReport.tournamentPointsHeader', [initialDateShort]).toUpperCase() + "\n";
    byGrowth = _.sortBy(stats, "currTournamentScore").reverse();
    top10 = _.take(byGrowth, 25);
    s += exports.makeTable(top10, {columns: ["currTournamentScore", "tournamentSum", "reportUsername"]}) + "\n";

    s += "### " + opts.i18n.t('site.fellowship.weeklyReport.top8ByPercentage').toUpperCase() + "\n";
    if( _.size(membersWithEnoughData) > 0 ) {
        byGrowth = _.sortBy(membersWithEnoughData, "currPercent").reverse();
        top10 = _.take(byGrowth, 8);//.splice(0,10);
        s += exports.makeTable(top10, {columns: ["currPercentPretty", "reportUsername"]}) + "\n";
    } else {
        s += opts.i18n.t('site.fellowship.weeklyReport.insufficientHistory1Week') + "\n\n";
    }

    let membersWith4Weeks = _.filter( membersWithEnoughData, function(m) { return m.initialScore; });
    s += "### " + opts.i18n.t('site.fellowship.weeklyReport.top8ByPointsSince', [initialDateShort]).toUpperCase() + "\n";
    if( _.size(membersWith4Weeks) ) {
        byGrowth = _.sortBy(membersWith4Weeks , "totalDelta").reverse();
        top10 = _.take(byGrowth, 8);//.splice(0,10);
        s += exports.makeTable(top10, {columns: ["totalDelta", "reportUsername"]}) + "\n";
    }
    else {
        s += opts.i18n.t('site.fellowship.weeklyReport.insufficientHistory4Weeks') + "\n\n";
    }

    s += "### " + opts.i18n.t('site.fellowship.weeklyReport.top8ByPercentageSince', [initialDateShort]).toUpperCase() + "\n";
    if( _.size(membersWith4Weeks) ) {
        byGrowth = _.sortBy(membersWith4Weeks , "totalPercent").reverse();
        top10 = _.take(byGrowth, 8);//.splice(0,10);
        s += exports.makeTable(top10, {columns: ["totalPercentPretty", "reportUsername"]}) + "\n";
    }
    else {
        s += opts.i18n.t('site.fellowship.weeklyReport.insufficientHistory4Weeks') + "\n\n";
    }

    s += opts.i18n.t("site.fellowship.weeklyReport.reportGeneratedBy") + '\n' + elvenStats.getFellowshipLink( _.first(opts.users).server, _.first(opts.users).fellowshipId) + "\n";

    if( s.length > 2000 && opts.makeReportFitInOneMessage ) {
        if( opts.usernameMaxLength <= 4) {
            return "WARNING: UNABLE TO MAKE ENTIRE REPORT FIT IN ONE EMAIL\n" + s;
        }
        opts.usernameMaxLength -= 2;
        return exports.weeklyFellowshipReport(opts);
    } else {
        return s;
    }

    // let tourneyBestsPoints = _.map(stats, function(user) {
    //     return {
    //         username: user.username,
    //         date: user.weeklyBest.tournamentBestPoints.date,
    //         score: user.weeklyBest.tournamentBestPoints.points
    //
    //     }
    // })
    //
    // let growthBests = _.map(stats, function(user) {
    //     return {
    //         username: user.username,
    //         date: user.weeklyBest.growthBest.date,
    //         points: user.weeklyBest.growthBest.points
    //     }
    // })
    //
    // let tournamentBestRank = _.map(stats, function(user) {
    //     return {
    //         username: user.username,
    //         date: user.weeklyBest.tournamentBestRank.date,
    //         rank: user.weeklyBest.tournamentBestRank.rank
    //     }
    // })
}

function getWeeklyBests(user, reportDate, i18n) {
    var tournaments = _.filter( user.tournaments, function (t) {
        return moment.utc(t.date).toDate() > moment.utc("2017-11-02").toDate() &&
               moment.utc(t.date).toDate() < moment.utc(reportDate).toDate();
    });

    var scoreHistory = _.filter( user.scoreHistory, function(score) { return moment(score.date).toDate() >= moment.utc("2017-11-12").toDate() });
    var deltaDeets = { points: -9999999 };
    for(var i= scoreHistory.length-1; i > 0; i--) {
        var curr = scoreHistory[i];
        var prev = scoreHistory[i-1];
        var delta = parseInt(curr.score) - parseInt(prev.score);

        if( delta > deltaDeets.points && delta > 0 ) {
            deltaDeets = {
                points: delta,
                date: curr.date,
                description: i18n.t('site.fellowship.weeklyReport.mostPointsInAWeek'),
                value: delta,
            }
        }
    }


    let filteredTournaments = _.filter( tournaments, function(t) {
        try {
            t.rank = t.rank ? parseInt(t.rank) : 0;
            t.points = t.rank ? parseInt(t.points) : 0;
        } catch(err) { console.error("invalid rank or points for user"); }

        return t.date && _.isNumber(t.points) && t.points > 0 && _.isNumber(t.rank) && t.rank < 3000;
    });

    //console.log( "filtered tournaments: " + _.size(filteredTournaments) );
    let bestTourneyPoints = _.first( _.sortBy(filteredTournaments, "points").reverse() );
    if( bestTourneyPoints ) {
        bestTourneyPoints.value = bestTourneyPoints.points;
        bestTourneyPoints.description = i18n.t('site.fellowship.weeklyReport.highestTournamentScore');
    }
    let bestTourneyRank = _.first( _.sortBy(filteredTournaments, "rank").reverse() );
    if( bestTourneyRank ) {
        bestTourneyRank.value = bestTourneyRank.rank;
        bestTourneyRank.description = i18n.t('site.fellowship.weeklyReport.highestTournamentRank');
    }

    var retVal = {
        tournamentBestPoints: bestTourneyPoints,
        tournamentBestRank: bestTourneyRank,
        growthBest: deltaDeets,
    };

    //console.log(retVal);

    return retVal;
}

function getAccoladeObj(stats, property) {
    try {
       // console.log("_size of stats in getAccoladeObj: " + _.size(stats) + " property: " + property );
        return _.first( _.sortBy(stats, property).reverse() );
    }
    catch(err) {
        return null;
    }
}

function getAccolade(stats, property, suffix, i18n) {
   // console.log("_size of stats in getAccolade: " + _.size(stats) );
    let r = getAccoladeObj(stats, property);
    if( !r ) {
        return i18n ? i18n.t('site.fellowship.weeklyReport.insufficientHistory1Week') : "ERROR"; // When error just don't include
    }
    return "" + r.reportUsername + " - " + r[property] + (suffix || "");
}

exports.makeTable = function makeTable(data, opts) {
    var mergedOpts = {
        showHeaders: false,
        //maxWidth: 6,
        truncate: true,
        truncateMarker: "",
        columnSplitter: ' ',
        headingTransform: function(data) {
            return data;   // Default transform is to Uppercase
        },
        config: {
            currDelta: {align: 'right'},
            currPercentPretty: {align: 'right'}
        }
    };
    _.extend(mergedOpts, opts);

    // keys was used by tablify, switched impl to columnize which uses .columns
    if( mergedOpts.keys ) {
        mergedOpts.columns = mergedOpts.keys;
        delete mergedOpts.keys;
    }

    var s = columnify(data, mergedOpts);

    var lines = s.split("\n");
    s = "";
    _.each(lines, function(l) {
        s += l.trimRight() + "\n";
    });
    return s;
};
    // makeTableTablify: function(data, opts) {
    //     var mergedOpts = {
    //         has_header: false,
    //         spacer: " ",
    //         show_index: false,
    //         row_start: "",
    //         row_end: "",
    //         row_sep_char: "",
    //         columnSplitter: ' ',
    //     };
    //     mergedOpts.has_header = false;
    //     mergedOpts.keys = opts.columns;
    //     var s = tablify(data, mergedOpts);
    //     return s;
    // }
// }


// WEBPACK FOOTER //
// ./src/lib/elven-weekly-report.js